<template>
  <div class="platform-selector">
    <h3 class="h3">
      Platforms access policy
    </h3>
    <div class="node-form__tags tags">
      <div>
        <md-radio
          v-model="mode"
          value="common"
          class="md-primary"
          @change="modeChanged(mode)"
        >
          Common
        </md-radio>
        <md-radio
          v-model="mode"
          value="blacklist"
          @change="modeChanged(mode)"
        >
          Blacklist
        </md-radio>
        <md-radio
          v-model="mode"
          value="whitelist"
          class="md-primary"
          @change="modeChanged(mode)"
        >
          Whitelist
        </md-radio>
      </div>
      <md-autocomplete
        v-if="mode!=='common'"
        v-model="selectedPlatform"
        class="tags__input"
        :md-options="platforms"
        :md-fuzzy-search="false"
        @md-selected="addPlatform"
      >
        <label>choose platform</label>

        <template
          slot="md-autocomplete-item"
          slot-scope="{ item, term }"
        >
          <md-highlight-text :md-term="term">
            {{ item }}
          </md-highlight-text>
        </template>
      </md-autocomplete>

      <p v-if="mode==='blacklist'">
        Enable all platforms except:
      </p>
      <p v-if="mode==='whitelist'">
        Disable all platforms except:
      </p>

      <md-chip
        v-for="pname in selectedPlatforms"
        :key="pname"
        class="md-primary"
        md-deletable
        style="margin-right: 3px !important;"
        @click="deleteChip(pname)"
      >
        {{ pname }}
      </md-chip>
    </div>
  </div>
</template>
<script>
    export default {
        name: "PlatformsSelector",
        props: {
          initialMode: { type: String, required: true },
          initialPlatforms: { type: Array, required: true }
        },
        data() {
            return {
                mode: "common",
                platforms: ["all", "iOS", "macos", "android", "windows", "web"],
                selectedPlatform: "",
                selectedPlatforms: [],
            };
        },
        watch: {
            "initialMode": "updateFromProps",
            "initialPlatforms": "updateFromProps",
        },
        mounted() {
            // if props are passed, use them as the initial state
            if (this.$props.initialMode || this.$props.initialPlatforms) {
                this.updateFromProps();
            }
        },
        methods: {
            modeChanged() {
                this.$emit("platformsModeChanged", this.mode);
            },
            addPlatform(name) {
                this.selectedPlatforms.push(name);

                this.$emit("platformsListChanged", this.selectedPlatforms);

                this.selectedPlatform = "";
            },
            deleteChip(cname) {
                this.selectedPlatforms = this.selectedPlatforms.filter(el => {
                    return el !== cname;
                });

                this.$emit("platformsListChanged", this.selectedPlatforms);
            },
            getShortcutById(id) {
                this.$http.get("/v1/shortcut/id/" + id).then(
                    res => {
                        this.mode = res.data.shortcut.platform_access_type;

                        this.$emit("platformsModeChanged", this.mode);

                        res.data.shortcut.platforms ? this.selectedPlatforms = res.data.shortcut.platforms : this.selectedPlatforms = [];

                        this.$emit("platformsListChanged", this.selectedPlatforms);
                    },
                    err => {
                        console.error(err);
                    },
                );
            },
            updateFromProps() {
                this.mode =  this.$props.initialMode || "common";
                this.selectedPlatforms = this.$props.initialPlatforms || [];
            }
        }
    };
</script>
